import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';
import { getFileIcon } from '@/utils/getFileIcon';
import { downloadFile } from '@/utils/downloadFile';
import FilePreviewModal from '@/components/FilePreviewModal';
import { isPreviewableExtension } from '@/utils/previewableFileExtensions';

type FileTableItemProps = {
  url: string;
  fileName: string;
  path: string;
};

const FileTableItem = ({ url, fileName, path }: FileTableItemProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const ext = fileName?.split('.')?.pop()?.toLowerCase() || '';

  const handleClick = () => {
    if (ext === "pdf") {
      window.open(url, '_blank');
    } else if (isPreviewableExtension(ext)) {
      setIsOpenModal(true);
    } else {
      downloadFile(path, fileName);
    }
  };

  return (
    <>
      <Tooltip
        title={isPreviewableExtension(ext) ? 'Preview file' : 'Download file'}
        arrow
      >
        <Box
          onClick={handleClick}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
        >
          {getFileIcon(fileName)}
          {fileName}
        </Box>
      </Tooltip>

      {isPreviewableExtension(ext) && (
        <FilePreviewModal
          isOpen={isOpenModal}
          toggleModal={() => setIsOpenModal(!isOpenModal)}
          fileName={fileName}
          path={path}
          previewUrl={url}
        />
      )}
    </>
  );
};

export default FileTableItem;